export default "__VITE_ASSET__3b4f2741__"